import type {AppIconProps} from "../Icons.types";
import {getClassNames} from "../Icons.utils";
import styles from "./Delete.module.scss";

export const AppDeleteIcon = (props: AppIconProps) => {
  const {className, ...rest} = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg {...rest} className={classNames} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M13.3643 13.3636C13.7549 12.9731 13.7549 12.3399 13.3643 11.9494L8.41459 6.99963L13.3643 2.04988C13.7549 1.65936 13.7549 1.02619 13.3643 0.635667C12.9738 0.245143 12.3406 0.245143 11.9501 0.635667L7.00037 5.58541L2.05062 0.635666C1.6601 0.245142 1.02694 0.245142 0.636412 0.635666C0.245888 1.02619 0.245888 1.65936 0.636412 2.04988L5.58616 6.99963L0.63641 11.9494C0.245886 12.3399 0.245886 12.9731 0.63641 13.3636C1.02693 13.7541 1.6601 13.7541 2.05062 13.3636L7.00037 8.41384L11.9501 13.3636C12.3406 13.7541 12.9738 13.7541 13.3643 13.3636Z" fill="#737781"/>
    </svg>
  );
};
